<template>
  <div style="background:#fff">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="待审批" name="first">
        <div style="padding:0px 20px 0px 24px">
          <div
            class="flex_between_nowrap"
            style="margin-top:20px;margin-bottom:30px"
          >
            <div>
              <el-select
                @change="firstTableSearch"
                size="small"
                style="width:160px;margin-right:10px"
                v-model="firstparams['queryType']"
              >
                <el-option
                  v-for="item in optionsArr"
                  :key="item.label"
                  :label="item.label"
                  :value="item.model"
                ></el-option>
              </el-select>
              <el-input
                clearable
                placeholder="请输入资产名/资产类型"
                size="small"
                v-model="firstparams['search']"
                style="width:300px;"
              >
                <i
                  slot="suffix"
                  class="el-icon-search inputIcon "
                  @click.stop="firstTableSearch"
                ></i>
              </el-input>
            </div>
            <!-- <div class="flex_end">
              <el-button type="submit" @click="add_click(activeName)"
                >新增</el-button
              >
            </div> -->
          </div>
          <x-table
            url="/pc/examine/page"
            ref="firstxTable"
            :params="firstparams"
            :axiosType="true"
          >
            <el-table-column
              :label="item.label"
              :prop="item.model"
              show-overflow-tooltip
              v-for="item in firstColumnArr"
              :key="item.model"
              ><template slot-scope="scope">
                <div style="width:100%" v-if="item.model == 'orderStatus'">
                  <el-tag
                    :style="assetStatusFulter(scope.row[item.model], false)"
                    >{{
                      assetStatusFulter(scope.row[item.model], true)
                    }}</el-tag
                  >
                </div>
                <el-tag v-else-if="item.model == 'orderType'">{{
                  orderTypeFulter(scope.row[item.model])
                }}</el-tag>
                  <span
              @click="global_detals(scope.row.id)"
              style=" text-decoration:underline;cursor:pointer"
              v-else-if="item.model == 'assetCode' || item.model == 'assetName'"
              >{{ scope.row[item.model] }}</span
            >
                <span v-else>{{ scope.row[item.model] }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              fixed="right"
              width="200"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="addColor"
                  @click="examine(scope.row)"
                  >审批</el-button
                >
              </template>
            </el-table-column>
          </x-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已审批" name="last">
        <div style="padding:0px 20px 0px 24px">
          <div
            class="flex_between_nowrap"
            style="margin-top:20px;margin-bottom:30px"
          >
            <div>
              <el-select
                @change="lastTableSearch"
                size="small"
                style="width:160px;margin-right:10px"
                v-model="lastparams['queryType']"
              >
                <el-option
                  v-for="item in optionsArr"
                  :key="item.label"
                  :label="item.label"
                  :value="item.model"
                ></el-option>
              </el-select>
              <el-input
                clearable
                placeholder="请输入资产名/资产类型"
                size="small"
                v-model="lastparams['search']"
                style="width:300px;"
              >
                <i
                  slot="suffix"
                  class="el-icon-search inputIcon "
                  @click.stop="lastTableSearch"
                ></i>
              </el-input>
            </div>
          </div>
          <x-table
            url="/pc/examine/page"
            ref="lastxTable"
            :params="lastparams"
            :axiosType="true"
          >
            <el-table-column
              :label="item.label"
              :prop="item.model"
              show-overflow-tooltip
              v-for="item in firstColumnArr"
              :key="item.model"
              ><template slot-scope="scope">
                <div style="width:100%" v-if="item.model == 'orderStatus'">
                  <el-tag
                    :style="assetStatusFulter(scope.row[item.model], false)"
                    >{{
                      assetStatusFulter(scope.row[item.model], true)
                    }}</el-tag
                  >
                </div>
                <el-tag v-else-if="item.model == 'orderType'">{{
                  orderTypeFulter(scope.row[item.model])
                }}</el-tag>
                <span v-else>{{ scope.row[item.model] }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              fixed="right"
              width="200"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="addColor"
                  @click="details(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </x-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      optionsArr: [
        {
          label: "不限",
          model: null,
        },
        {
          label: "领用",
          model: "receive",
        },
        {
          label: "退还",
          model: "refund",
        },

        {
          label: "借用",
          model: "borrow",
        },
        {
          label: "归还",
          model: "giveback",
        },
        {
          label: "变更",
          model: "change",
        },
        {
          label: "调拨",
          model: "allot",
        },
        {
          label: "维修中",
          model: "repair",
        },
        {
          label: "维修完成",
          model: "erepair",
        },
        {
          label: "处置",
          model: "dispose",
        },
      ],
      lastColumnArr: [
        {
          label: "状态",
          model: "orderStatus",
        },
        {
          label: "单号",
          model: "orderNo",
        },
        {
          label: "资产数量",
          model: "assetNum",
        },
        {
          label: "实还日期",
          model: "retTime",
        },
        {
          label: "申请人",
          model: "createName",
        },
        {
          label: "申请时间",
          model: "createTime",
        },
        {
          label: "备注",
          model: "remark",
        },
        {
          label: "审批人",
          model: "examineName",
        },

        {
          label: "审批时间",
          model: "examineTime",
        },
        {
          label: "审批备注",
          model: "examineRemark",
        },
      ],
      activeName: "first",
      /* first start */
      firstparams: {
        await: true,
        queryType: null,
      },
      lastparams: {
        await: false,
        queryType: null,
      },
      firstColumnArr: [
        {
          label: "状态",
          model: "orderStatus",
        },
        {
          label: "单号",
          model: "orderNo",
        },
        {
          label: "资产数量",
          model: "assetNum",
        },
        {
          label: "资产类型",
          model: "orderType",
        },
        {
          label: "备注",
          model: "remark",
        },
        {
          label: "申请人",
          model: "createName",
        },
        {
          label: "申请时间",
          model: "createTime",
        },
      ],
      /* first end */
    };
  },
  mounted() {},
  methods: {
    orderTypeFulter(model) {
      let str = "";
      for (let i = 0; i < this.optionsArr.length; i++) {
        if (this.optionsArr[i].model == model) {
          str = this.optionsArr[i].label;
          break;
        }
      }
      return str;
    },

    examine(row) {
      /*   {
          label: "领用",
          model: "receive",
        },
        {
          label: "退还",
          model: "refund",
        },

        {
          label: "借用",
          model: "borrow",
        },
        {
          label: "归还",
          model: "giveback",
        },
        {
          label: "变更",
          model: "change",
        },
        {
          label: "调拨",
          model: "allot",
        },
        {
          label: "维修",
          model: "repair",
        },
        {
          label: "处置",
          model: "dispose",
        }, */

      switch (row.orderType) {
        case "change":
          this.$createDialog(this, {
            dialogConfig: { title: "资产变更的审批", width: "860px" },
            namespace: "asset_change_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              callBack: this.firstTableSearch,
              defaultRow: row.inJson,
            },
          });

          break;

        case "receive":
          this.$createDialog(this, {
            dialogConfig: { title: "资产领用的审批", width: "860px" },
            namespace: "asset_receive_receiveEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              callBack: this.firstTableSearch,
              defaultRow: row.inJson,
            },
          });

          break;

        case "refund":
          this.$createDialog(this, {
            dialogConfig: { title: "资产退还审批", width: "860px" },
            namespace: "asset_receive_returnEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              callBack: this.firstTableSearch,
              defaultRow: row.inJson,
            },
          });

          break;

        case "borrow":
          this.$createDialog(this, {
            dialogConfig: { title: "资产借用审批", width: "860px" },
            namespace: "asset_borrow_borrowEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              callBack: this.firstTableSearch,
              defaultRow: row.inJson,
            },
          });

          break;

        case "giveback":
          this.$createDialog(this, {
            dialogConfig: { title: "资产归还审批", width: "860px" },
            namespace: "asset_borrow_returnEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              callBack: this.firstTableSearch,
              defaultRow: row.inJson,
            },
          });
          break;
        case "allot":
          this.$createDialog(this, {
            dialogConfig: { title: "资产调拨审批", width: "860px" },
            namespace: "asset_allot_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              callBack: this.firstTableSearch,
              defaultRow: row.inJson,
            },
          });
          break;

        case "repair":
          this.$createDialog(this, {
            dialogConfig: { title: "资产维修审批", width: "860px" },
            namespace: "asset_maintain_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              callBack: this.firstTableSearch,
              defaultRow: row.inJson,
            },
          });
          break;
        case "erepair":
          this.$createDialog(this, {
            dialogConfig: { title: "资产维修审批", width: "860px" },
            namespace: "asset_maintain_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              callBack: this.firstTableSearch,
              defaultRow: row.inJson,
            },
          });
          break;
        case "dispose":
          this.$createDialog(this, {
            dialogConfig: { title: "资产处置审批", width: "860px" },
            namespace: "asset_dispose_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              callBack: this.firstTableSearch,
              defaultRow: row.inJson,
            },
          });
          break;
      }
    },
    details(row) {
      /*   {
          label: "领用",
          model: "receive",
        },
        {
          label: "退还",
          model: "refund",
        },

        {
          label: "借用",
          model: "borrow",
        },
        {
          label: "归还",
          model: "giveback",
        },
        {
          label: "变更",
          model: "change",
        },
        {
          label: "调拨",
          model: "allot",
        },
        {
          label: "维修",
          model: "repair",
        },
        {
          label: "处置",
          model: "dispose",
        }, */

      switch (row.orderType) {
        case "change":
          this.$createDialog(this, {
            dialogConfig: { title: "资产变更的详情"+'--审批结果'+this.assetStatusFulter(row.orderStatus,true), width: "860px" },
            namespace: "asset_change_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });

          break;

        case "receive":
          this.$createDialog(this, {
            dialogConfig: { title: "资产领用的详情"+'--审批结果'+this.assetStatusFulter(row.orderStatus,true), width: "860px" },
            namespace: "asset_receive_receiveEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });

          break;

        case "refund":
          this.$createDialog(this, {
            dialogConfig: { title: "资产退还详情"+'--审批结果'+this.assetStatusFulter(row.orderStatus,true), width: "860px" },
            namespace: "asset_receive_returnEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });

          break;

        case "borrow":
          this.$createDialog(this, {
            dialogConfig: { title: "资产借用详情"+'--审批结果'+this.assetStatusFulter(row.orderStatus,true), width: "860px" },
            namespace: "asset_borrow_borrowEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });

          break;

        case "giveback":
          this.$createDialog(this, {
            dialogConfig: { title: "资产归还详情"+'--审批结果'+this.assetStatusFulter(row.orderStatus,true), width: "860px" },
            namespace: "asset_borrow_returnEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });
          break;
        case "allot":
          this.$createDialog(this, {
            dialogConfig: { title: "资产调拨详情"+'--审批结果'+this.assetStatusFulter(row.orderStatus,true), width: "860px" },
            namespace: "asset_allot_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });
          break;

        case "repair":
          this.$createDialog(this, {
            dialogConfig: { title: "资产维修详情"+'--审批结果'+this.assetStatusFulter(row.orderStatus,true), width: "860px" },
            namespace: "asset_maintain_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });
          break;
        case "erepair":
          this.$createDialog(this, {
            dialogConfig: { title: "资产维修详情"+'--审批结果'+this.assetStatusFulter(row.orderStatus,true), width: "860px" },
            namespace: "asset_maintain_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });
          break;
        case "dispose":
          this.$createDialog(this, {
            dialogConfig: { title: "资产处置详情"+'--审批结果'+this.assetStatusFulter(row.orderStatus,true), width: "860px" },
            namespace: "asset_dispose_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: row.asset,
              defaultRow: row.inJson,
            },
          });
          break;
      }
    },
    assetStatusFulter(data, flag) {
      let str = "";
      if (flag) {
        switch (data) {
          case "await":
            str = "待审";

            break;

          case "pass":
            str = "同意";

            break;
          case "apass":
            str = "通过";

            break;
          case "cancel":
            str = "取消";

            break;
          case "refuse":
            str = "拒绝";

            break;
        }
      } else {
        switch (data) {
          case "pass":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "await":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "apass":
            str = "color:#42b983;background:#f0f9eb;";

            break;

          case "cancel":
            str = "color:#e0e0e0;background:#7c7c7c;";

            break;
          case "refuse":
            str = "color:#ffd0cc;background:#fa675c;";
            break;
        }
      }
      return str;
    },
    revoke(id) {
      this.$alertMsg.confirm("即将撤销申请,是否继续？", () => {
        this.$requestAxios(
          {
            url: "/pc/operate/repeal",
            data: { id },
          },
          (data) => {
            this.$success();
            this.firstTableSearch();
          }
        );
      });
    },
    firstTableSearch() {
      this.$refs.firstxTable.search();
    },
    lastTableSearch() {
      this.$refs.lastxTable.search();
    },
    handleClick(data) {
      this.firstTableSearch();
      this.lastTableSearch();
    },
  },
};
</script>
<style scoped></style>
